import React from 'react';
import { Button, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import BaseDialog from '@material-ui/core/Dialog';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';

import './Dialog.scss';
import { BUTTON_COLOR, BUTTON_VARIANT, DIALOG_SIZE } from '../form/enum/formProps';

interface DialogProps {
  title: string;
  buttonActionLabel: string;
  onClose?: () => void;
  onSave?: () => void;
  open: boolean;
  disableBackdropClick?: boolean;
  dialogSize?: DIALOG_SIZE;
  fullWidth?: boolean;
  hideActions?: boolean;
  isTabSet?: boolean;
}

const Dialog: React.FC<DialogProps> = (props) => {
  const { t } = useTranslation();
  const classes = clsx({
    'Dialog-Wrapper': true,
    'Dialog-Tabs': props.isTabSet,
  });

  return (
    <BaseDialog
      className={classes}
      open={props.open}
      disableBackdropClick={props.disableBackdropClick}
      maxWidth={props.dialogSize}
      fullWidth={props.fullWidth}
    >
      {!props.isTabSet && <DialogTitle>{t(props.title)}</DialogTitle>}
      <DialogContent className="Dialog-Content">{props.children}</DialogContent>
      {!props.hideActions && (
        <DialogActions>
          <Button
            className="Dialog-Close"
            variant={BUTTON_VARIANT.CONTAINED}
            color={BUTTON_COLOR.DEFAULT}
            onClick={props.onClose}
          >
            {t('button.close')}
          </Button>
          <Button
            className="Dialog-Save"
            variant={BUTTON_VARIANT.CONTAINED}
            color={BUTTON_COLOR.PRIMARY}
            onClick={props.onSave}
          >
            {t(props.buttonActionLabel)}
          </Button>
        </DialogActions>
      )}
    </BaseDialog>
  );
};

export default Dialog;
